'use client';

import { useState, useCallback } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect.js';

var useElementSize = function () {
    var _a = useState(null), ref = _a[0], setRef = _a[1];
    var _b = useState({
        width: 0,
        height: 0
    }), size = _b[0], setSize = _b[1];
    var handleSetSize = useCallback(function () {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    useIsomorphicLayoutEffect(function () {
        if (typeof window === 'undefined')
            return;
        handleSetSize();
        window.addEventListener('resize', handleSetSize);
        return function () {
            window.removeEventListener('resize', handleSetSize);
        };
    }, [handleSetSize]);
    return [setRef, size, ref];
};

export { useElementSize as default };
//# sourceMappingURL=useElementSize.js.map
